module.exports = __webpack_public_path__ + "img/icon-media.7c630088.svg";